/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoNftLevelStatRequest model module.
 * @module model/PerplayStatisticsControllerDtoNftLevelStatRequest
 * @version 1.0
 */
class PerplayStatisticsControllerDtoNftLevelStatRequest {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoNftLevelStatRequest</code>.
     * @alias module:model/PerplayStatisticsControllerDtoNftLevelStatRequest
     * @param beginDate {Date} 
     * @param endDate {Date} 
     */
    constructor(beginDate, endDate) { 
        
        PerplayStatisticsControllerDtoNftLevelStatRequest.initialize(this, beginDate, endDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, beginDate, endDate) { 
        obj['beginDate'] = beginDate;
        obj['endDate'] = endDate;
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoNftLevelStatRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoNftLevelStatRequest} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoNftLevelStatRequest} The populated <code>PerplayStatisticsControllerDtoNftLevelStatRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoNftLevelStatRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoNftLevelStatRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoNftLevelStatRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PerplayStatisticsControllerDtoNftLevelStatRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

PerplayStatisticsControllerDtoNftLevelStatRequest.RequiredProperties = ["beginDate", "endDate"];

/**
 * @member {Date} beginDate
 */
PerplayStatisticsControllerDtoNftLevelStatRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
PerplayStatisticsControllerDtoNftLevelStatRequest.prototype['endDate'] = undefined;






export default PerplayStatisticsControllerDtoNftLevelStatRequest;

